import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../sidebar/sidebar";
import Layout from "../layout/layout";
import style from "./Mp4FileUpload.module.css";
import Button from "../button/Button";
import { MdLocalMovies } from "react-icons/md";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import useCommonRating from "../apiCall/RatingandGenre";
import {
  categoriesList,
  GenresList,
  MovieDataList,
  moviesUpdate,

  adminContent,
  prefillSeriesListApi,
  prefillSeasonListApi,
  addNewEpisode,
  updateTableData,
  liveChannelCreate,
  getEventType,
  getStreamType,
  getLiveChannelDetails,
  putLiveChannelUpdate,
  SeasonShowApi,
  UploadImage,
} from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import { FaCopy } from "react-icons/fa";
import SkeletonLoader from "../skeletonLoader/SkeletonLoader";
import BasicInformation from "../Information/BasicInformation";
import MediaAssets from "../Information/MediaAssests";
import TrailerClips from "../Information/TrailerClips";
import CastCrewMembers from "../Information/CastCrewMembers";
import Technical from "../Information/Technical";
import Publishing from "../Information/Publishing";
import ContentRightsConfirmation, { isCreator, CONTENT_RIGHTS_ERROR } from "../Information/ContentRightsConfirmation";
import { appendPublishingPayload, mapPublishingFromApi, showsPlacementSection, validateCategoryPlacements } from "../Information/PublishingPayload";
import useCategoryPlacements from "../../hooks/useCategoryPlacements";
import useAiVideoAnalysis from "../../hooks/useAiVideoAnalysis";
import AiAnalysisProgress from "../aiAssist/AiAnalysisProgress";
import AiStudio from "../aiStudio/AiStudio";
import { useAiEnabled } from "../../context/AppConfigContext";
import { languageName } from "../../services/ai/aiStudioTasks";
import {
  subtitleResultToFiles,
  mergeSubtitleFiles,
  dubResultToTracks,
  mergeAudioTracks,
  trailerResultToRow,
  describeMerge,
} from "../../services/ai/applyAiResults";

const getHash = () => {
  try {
    return typeof window !== "undefined" ? window.location.hash : "";
  } catch {
    return "";
  }
};

// AI-generated artwork comes back as a TEMPORARY analyze-server URL
// (http://localhost:3002/api/v1/artifacts/<job>/poster.jpg). Those files live in
// the analyze server's OS temp dir and VANISH when it restarts — so if we saved
// that URL straight to the DB, poster/backdrop would 404 forever after the next
// restart (exactly the bug we hit). This helper pulls the image down and re-hosts
// it on Bunny via the normal image-upload endpoint, returning the PERMANENT Bunny
// URL. It's the same fetch→File→upload pattern subtitles and dubs already use.
// Returns null on any failure so the caller can fall back to the original URL.
const rehostArtworkToBunny = async (url, fallbackName = "artwork.jpg") => {
  try {
    if (!url || typeof url !== "string") return null;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`fetch ${res.status}`);
    const blob = await res.blob();
    const type = blob.type || "image/jpeg";
    const name = url.split("/").pop()?.split("?")[0] || fallbackName;
    const file = new File([blob], name, { type });
    const fd = new FormData();
    fd.append("image", file);
    const response = await UploadImage(fd);
    const bunnyUrl =
      response?.data?.data?.upload?.file_url ||
      response?.data?.data?.url ||
      response?.data?.data?.image_url ||
      response?.data?.url ||
      response?.data?.image_url ||
      "";
    return bunnyUrl || null;
  } catch (err) {
    console.warn(`[ai-artwork] re-host to Bunny failed for ${url}:`, err?.message || err);
    return null;
  }
};

const ImageFileUpload = () => {
  const location = useLocation();
  const params = useParams();
  const seriesBannerImage = useRef(null);
  const seriesPortraitImage = useRef(null);
  const [searchParams] = useSearchParams();
  const {
    video_id,
    movieId,
    name: stateName,
    seriesId: stateSeriesId,
    seasonId: stateSeasonId,
    nextEpisodeNumber: stateNextEpisodeNumber,
    metadata_id,
    live_type,
    mediaLibrary,
    episode,
  } = location.state || {};
  const isEpisodeAddRoute =
    episode === "episode" &&
    !video_id &&
    !movieId &&
    !metadata_id &&
    Boolean(
      (stateSeriesId && stateSeasonId && stateNextEpisodeNumber) ||
      (params?.id && params?.seriesId && params?.seasonId)
    );
  const name = stateName || (isEpisodeAddRoute ? "episodes" : "");
  const seriesId = stateSeriesId || (isEpisodeAddRoute ? params.id : "");
  const seasonId = stateSeasonId || (isEpisodeAddRoute ? params.seriesId : "");
  const nextEpisodeNumber =
    stateNextEpisodeNumber || (isEpisodeAddRoute ? params.seasonId : "");
  const hash = getHash();
  const resolvedMovieId = video_id || movieId;
  const navigate = useNavigate();
  const { ratingOptions, accessOptions } = useCommonRating();
  const [movieData, setMovieData] = useState(null);
  const [isPortraitUploaded, setIsPortraitUploaded] = useState(false);
  const [isLandscapeUploaded, setIsLandscapeUploaded] = useState(false);
  const [imagePreviewURL, setImagePreviewURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const [seriesList, setSeriesList] = useState([]);
  const [seasonList, setSeasonList] = useState([]);
  const [bannerPreviewURL, setBannerPreviewURL] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [genresDataList, setGenresDataList] = useState();
  const [categoriesData, setCategoriesData] = useState();
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [castList, setCastList] = useState([]);
  const [crewList, setCrewList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [activeImageType, setActiveImageType] = useState(null);
  const [video, setVideo] = useState();
  // True right after Duration was auto-filled from the selected video's real,
  // Bunny-encoded length (seconds) — used only to show a brief clarifying
  // note next to the field, since its value won't look like the "120
  // minutes" placeholder's convention. Cleared the moment the field is
  // hand-edited, same as the (separate, unrelated) AI-field-badge pattern.
  const [durationAutoFilled, setDurationAutoFilled] = useState(false);
  // Duration was auto-detected from the currently selected video's real
  // length (seconds) — the field is then shown greyed out. Saved values on
  // edit never set this, so they stay correctable; it is recomputed on every
  // new video selection and cleared when the video is removed/replaced.
  const [durationPrefilled, setDurationPrefilled] = useState(false);
  const [trailer, setTrailer] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [streamData, setStreamData] = useState();
  const [eventData, setEventData] = useState();
  const { state } = useLocation();
  const [rightsConfirmed, setRightsConfirmed] = useState(false);
  const [showRightsError, setShowRightsError] = useState(false);
  const [loadingState, setLoadingState] = useState({ Publish: false, draft: false });
  const [progress, setProgress] = useState(0);
  // Open on Media & Assets first — selecting a video is the entry point that
  // triggers AI auto-fill of the sections below.
  const [activeAccordion, setActiveAccordion] = useState("media");
  const [heroPreviewURL, setHeroPreviewURL] = useState(null);
  const [logoPreviewURL, setLogoPreviewURL] = useState(null);
  const actualFetchedVideoId = useRef(null);
  const selectedLibraryVideoId = useRef(null);
  const [seasonHeader, setSeasonHeader] = useState("");
  const [seasonNum, setSeasonNum] = useState("");

  const [technicalData, setTechnicalData] = useState({
    max_quality: "", frame_rate: "", hdr: "", aspect_ratio: "",
    drm: "", max_streams: "", geo_restrictions: "",
    video_codec: "", audio_codec: "", bitrate: "",
  });

  // Detected audio tracks (language / codec / channels). Populated by AI and
  // editable in Media & Assets. Not tied to the base form, so kept separately.
  const [audioTracks, setAudioTracks] = useState([]);
  // Seek-bar preview ("trickplay") thumbnails generated by AI: { vttUrl, spriteUrl, … }.
  // Sent as thumbnails_vtt_url/thumbnails_sprite_url on save → stored in other_info.
  const [thumbnailsData, setThumbnailsData] = useState(null);

  const [publishingData, setPublishingData] = useState({
    status: "", access: "", access_type: "", access_types: [], rent_price: "", rent_duration_days: "", buy_price: "", currency: "", publishing_date: "", ppvPrice: "",
    licenseExpiry: "", featuredPlacement: "Not Featured", featuredUntil: "",
    category_placements: [],
  });
  // Flips true on the first blocked save so the Publishing accordion can show
  // its Category / Sub Category errors inline instead of only as a toast.
  // Owns the Experience Builder pages and the first Category row. Lives here,
  // not in <Publishing>, because that accordion unmounts while collapsed --
  // a user who never opens it must still get a seeded row and a loaded page
  // list, or the save blocks on a field that was never rendered. Disabled on
  // the episode route, where the section isn't shown at all.
  const showsCategorySection = showsPlacementSection(hash);
  const {
    sections: loadedSections,
    sectionsError,
    sectionsLoading,
    sectionsComplete,
    showPlacementErrors,
    setShowPlacementErrors,
    ensureRow,
  } = useCategoryPlacements({ enabled: showsCategorySection, setPublishingData });

  const [crewData, setCrewData] = useState({
    directors: "", writers: "", producers: "", composers: "",
  });
  const [castMembers, setCastMembers] = useState([]);
  const [ratingsData, setRatingsData] = useState({ imdb: "", rottenTomatoes: "", awards: "" });
  const [trailersList, setTrailersList] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [subtitleFiles, setSubtitleFiles] = useState([]);

  // ── AI-assisted metadata generation ──────────────────────────────────────
  // The analysis service/hook is intentionally decoupled from the form: it just
  // produces a normalized result; the effects below decide how to auto-fill.
  const ai = useAiVideoAnalysis();
  // AI master switch, from GET /config (CMS Settings page). False while the
  // config is still loading, so AI controls never flash on screen.
  const aiEnabled = useAiEnabled();
  // Form-field keys that currently hold an AI-generated value (drives badges).
  const [aiFields, setAiFields] = useState(() => new Set());
  const [aiDismissed, setAiDismissed] = useState(false);
  // Tracks the last video we kicked an analysis for, so re-renders don't retrigger.
  const aiVideoKeyRef = useRef(null);
  // Ensures a completed result is applied to the form only once.
  const aiAppliedRef = useRef(null);

  const selectHlsUrl = JSON.stringify(selectedVideos?.HLSPlaylistURL, null, 2);

  const handleCastCrewChange = (cast, crew) => {
    setCastList(cast);
    setCrewList(crew);
  };

  useEffect(() => {
    if (!loadingState.Publish && !loadingState.draft) {
      setProgress(0);
      return;
    }

    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 99 ? prev : prev + 1));
    }, 30);

    return () => clearInterval(interval);
  }, [loadingState.Publish, loadingState.draft]);

  const fetchStreamData = async () => {
    try {
      const response = await getStreamType();
      setStreamData(response?.data?.data?.map((item) => ({ id: item.id, name: item.name.toLowerCase() })) || []);
    } catch (error) {
      showToast(error.response.data.message, "error");
    }
  };

  const fetchEventType = async () => {
    try {
      const response = await getEventType();
      setEventData(response?.data?.data?.map((item) => ({ id: item.id, name: item.name.toLowerCase() })) || []);
    } catch (error) {
      showToast(error.response.data.message, "error");
    }
  };

  useEffect(() => {
    fetchStreamData();
    fetchEventType();
  }, []);

  const statusData = [
    { id: "Active", name: "Active" },
    { id: "Inactive", name: "Inactive" },
  ];

  const paramsData =
    name === "creator-movie" ? "Movie"
      : name === "movie" ? "Movie"
        : name === "podcasts" ? "Podcast"
          : name === "short-clips" ? "Short Clip"
            : name === "series" ? "Series"
              : name === "episodes" ? "Series"
                : name === "live-streams" ? "Live Stream"
                  : name === "Live Channels" ? "Live Channel"
                    : name === "Live Events" ? "Live Event"
                      : null;

  const portraitInputRef = useRef();
  const landscapeInputRef = useRef();

  const hasMetaFalseParam = searchParams.get("meta") === "false";
  const isEditing = hasMetaFalseParam
    ? Boolean(metadata_id)
    : Boolean(resolvedMovieId || (params?.id && !isEpisodeAddRoute));

  const [formData, setFormData] = useState({
    name: selectHlsUrl ? selectHlsUrl : "",
    "content-type": paramsData || "",
    genres: "",
    badges: "",
    rating: "",
    description: "",
    year: "",
    portrait: bannerPreviewURL?.id || null,
    landscape: null,
    status: "",
    access: "",
    episode_number: nextEpisodeNumber || "",
    series_id: seriesId || "",
    season_id: seasonId || "",
    stream_type: "",
    url: "",
    liveStatus: "",
    processed_HLS_URL: "",
    event_type: "",
    start_time: "",
    duration: "",
    end_time: "",
    content_warning: "",
    language: "",
    country: "",
    live_type:
      name === "Live Events" ? "Event"
        : name === "Live Channels" ? "Channel"
          : "",
    source_type: mediaLibrary ? "media" : "url",
    media_video_id: mediaLibrary ? (resolvedMovieId || null) : null, // seeded from the picked video's id
    loop: true,
  });

  const OTHER_INFO_KEYS = [
    "url", "event_type", "processed_HLS_URL", "stream_type",
    "liveStatus", "start_time", "end_time", "live_type",
    "source_type", "media_video_id", "loop",
  ];

  // Stable identity for the currently selected main-content video. Covers both
  // media-library items (have `id`) and freshly uploaded File objects (have `name`).
  const videoSelectionKey =
    video &&
    (video.id ||
      video.name ||
      video.HLSPlaylistURL ||
      video.bunny_cdn_url ||
      video.preview_url ||
      null);

  // AI metadata analysis is BUTTON-TRIGGERED (like dub/subtitles/thumbnails), not
  // automatic. The operator picks a video, then clicks "Generate metadata with AI"
  // to start it. Requires a selected non-live video (create mode only).
  const isLiveContent =
    formData["content-type"] === "Live Channel" ||
    formData["content-type"] === "Live Event";
  // aiEnabled first: with AI off for this deployment there is no button to
  // start metadata analysis, and nothing downstream can move `ai` out of idle.
  const canGenerateMetadata =
    aiEnabled && !isEditing && !isLiveContent && Boolean(videoSelectionKey);

  const handleGenerateMetadata = () => {
    if (!canGenerateMetadata || !video) {
      showToast("Select or upload a video first, then generate metadata.");
      return;
    }
    aiVideoKeyRef.current = videoSelectionKey;
    aiAppliedRef.current = null;
    setAiDismissed(false);
    ai.analyze(video);
  };

  // Auto-fill the form from a completed metadata result: only fields the user
  // hasn't already filled (never clobber manual input), remembering which ones came
  // from AI so the badges can render.
  //
  // Defined as a plain function rather than inlined in the effect because BOTH the
  // legacy "Generate metadata with AI" button and the AI Studio run need it, and
  // they drive two separate hook instances. A plain function closes over the current
  // render's state, which is what we want — callers invoke it imperatively.
  const applyMetadataResult = (result) => {
    if (!result) return;
    const patch = {};
    const filled = [];
    const isEmpty = (v) => v === undefined || v === null || v === "";

    // ── Text form fields (Basic Information) ──
    Object.entries(result.fields || {}).forEach(([key, meta]) => {
      if (isEmpty(formData[key])) {
        patch[key] = meta.value;
        filled.push(key);
      }
    });

    // ── Technical specs (resolution, frame rate, codecs, …) ──
    const techPatch = {};
    Object.entries(result.technical || {}).forEach(([key, meta]) => {
      if (isEmpty(technicalData[key])) {
        techPatch[key] = meta.value;
        filled.push(`tech:${key}`);
      }
    });
    if (Object.keys(techPatch).length > 0) {
      setTechnicalData((prev) => ({ ...prev, ...techPatch }));
    }

    // ── Artwork & hero clip (only when the slot is still empty) ──
    // AI artwork URLs point at the analyze server's TEMP dir — they die on its
    // next restart. So we show the temp URL immediately as a preview (fast), then
    // re-host it to Bunny in the BACKGROUND and swap the stored URL to the
    // permanent Bunny one. The re-hosted URL is what gets saved, so poster/backdrop
    // survive restarts. (Previously the raw localhost:3002 URL was saved directly —
    // that was the 404-after-restart bug.)
    const art = result.artwork || {};
    if (art.portrait && !isPortraitUploaded && isEmpty(formData.portrait)) {
      const tempUrl = art.portrait.value;
      setImagePreviewURL({ bunny_cdn_url: tempUrl });
      setIsPortraitUploaded(true);
      patch.portrait = tempUrl; // provisional; upgraded to Bunny URL below
      filled.push("portrait");
      rehostArtworkToBunny(tempUrl, "poster.jpg").then((bunnyUrl) => {
        if (bunnyUrl) {
          setImagePreviewURL({ bunny_cdn_url: bunnyUrl });
          setFormData((prev) => ({ ...prev, portrait: bunnyUrl }));
        }
      });
    }
    if (art.landscape && !isLandscapeUploaded && isEmpty(formData.landscape)) {
      const tempUrl = art.landscape.value;
      setBannerPreviewURL({ bunny_cdn_url: tempUrl });
      setIsLandscapeUploaded(true);
      patch.landscape = tempUrl; // provisional; upgraded to Bunny URL below
      filled.push("landscape");
      rehostArtworkToBunny(tempUrl, "backdrop.jpg").then((bunnyUrl) => {
        if (bunnyUrl) {
          setBannerPreviewURL({ bunny_cdn_url: bunnyUrl });
          setFormData((prev) => ({ ...prev, landscape: bunnyUrl }));
        }
      });
    }
    if (art.logo && !logoPreviewURL) {
      const tempUrl = art.logo.value;
      setLogoPreviewURL({ bunny_cdn_url: tempUrl });
      filled.push("logo");
      rehostArtworkToBunny(tempUrl, "logo.png").then((bunnyUrl) => {
        if (bunnyUrl) setLogoPreviewURL({ bunny_cdn_url: bunnyUrl });
      });
    }
    // NOTE: hero is a VIDEO (hero.mp4), not an image — the /image-upload endpoint
    // can't re-host it, so it stays a temp URL for now and will 404 after an
    // analyze-server restart. The right long-term source for the hero/preview clip
    // is Bunny's own encode-time PreviewAnimationURL (see the Bunny findings), not
    // an ffmpeg-cut temp file. Leaving hero as-is until we wire that up.
    if (art.hero && !heroPreviewURL) {
      setHeroPreviewURL(art.hero.value);
      filled.push("hero");
    }

    // ── Trailer (only when none exists yet) ──
    if (result.trailer?.value && trailersList.length === 0) {
      const t = result.trailer.value;
      setTrailersList([
        {
          id: Date.now(),
          label: t.title || "",
          type: t.type || "",
          description: t.description || "",
          url: t.url || "",
          duration: t.duration ?? null,
          videoFile: null, // user attaches the actual file; AI fills the rest
          thumbnail: t.thumbnail || null,
          subtitlesEnabled: false,
          subtitleFiles: [null, null, null],
          expanded: true,
          saved: false,
        },
      ]);
      filled.push("trailer");
    }

    // ── Audio tracks ──
    // Intentionally NOT auto-populated from metadata detection. Gemini's guessed
    // audio languages have NO actual audio file behind them, so pre-filling rows
    // like "Spanish (Dubbed)" created dead player-switcher options that play
    // nothing. The audio-track list is now populated ONLY by real tracks: a
    // manual upload (attachAudioFile) or an AI "Generate dub" — both carry a file.

    if (Object.keys(patch).length > 0) {
      setFormData((prev) => ({ ...prev, ...patch }));
    }
    if (filled.length > 0) {
      setAiFields(new Set(filled));
      // Reveal the freshly auto-filled fields so the user sees the result.
      setActiveAccordion("basic");
    }
  };

  // Legacy path: the per-section "Generate metadata with AI" button drives the `ai`
  // hook directly. Applied once per result via the ref guard.
  useEffect(() => {
    if (ai.status !== "complete" || !ai.result) return;
    if (aiAppliedRef.current === ai.result) return;
    aiAppliedRef.current = ai.result;
    applyMetadataResult(ai.result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ai.status, ai.result]);

  // ── AI Studio result handlers ────────────────────────────────────────────────
  // The Studio runs the same five jobs as the per-section panels but as one batch,
  // so each finished job needs a home. These handlers are the ONLY new write paths;
  // they reuse the very state setters the manual/legacy flows already use, so a
  // Studio-generated asset saves through the identical payload code.
  //
  // Unlike the legacy panels, a language that already exists is REPLACED rather
  // than skipped — the operator explicitly asked to generate it, so the new output
  // is the one they want (see applyAiResults.js).

  // Generated subtitles are handed DOWN to MediaAssets rather than written into this
  // component's `subtitleFiles` state.
  //
  // MediaAssets owns the subtitle UI state; `onSubtitleChange` only ever flows child →
  // parent. Writing the parent's copy directly (the first version of this) put the files
  // somewhere the subtitle panel never reads, so generated captions were invisible — and
  // worse, the next `onSubtitleChange` from MediaAssets would overwrite them with its own
  // empty list, silently losing them on save.
  //
  // The `token` makes each delivery distinct so the child applies it exactly once.
  const [aiSubtitleDrop, setAiSubtitleDrop] = useState(null);

  const handleStudioSubtitles = async (result) => {
    const { files, failed } = await subtitleResultToFiles(result);
    if (files.length === 0) {
      showToast(
        failed.length
          ? "Subtitles were generated but could not be downloaded. Try again."
          : "No subtitles were produced for this video.",
        "error"
      );
      return;
    }
    setAiSubtitleDrop({ files, token: Date.now() });

    // Trust the TRANSCRIPT for the spoken language, not the metadata job's guess.
    // The two are separate Gemini calls and they disagree: on a Hindi clip the
    // metadata job reported "English" while the transcription correctly produced a
    // Hindi original. Transcription is the authority here — it worked from the
    // dialogue end to end, whereas metadata infers the language while judging
    // everything else about the film.
    //
    // The original-language file is the one that isn't a translation.
    const spoken = (result?.subtitles || []).find((s) => !s.translated)?.language;
    if (spoken) {
      const code = String(spoken).toLowerCase();
      setFormData((prev) => {
        // Only correct an empty field or one AI filled in — never overwrite a value
        // the operator typed themselves.
        const isAiFilled = aiFields.has("language");
        const isEmpty = !prev.language;
        if (!isEmpty && !isAiFilled) return prev;
        if (prev.language === code) return prev;
        return { ...prev, language: code };
      });
      setAiFields((prev) => new Set(prev).add("language"));
    }
  };

  const handleStudioDub = async (result) => {
    const { tracks, failed } = await dubResultToTracks(result, languageName);
    if (tracks.length === 0) {
      showToast(
        failed.length
          ? "Dubbed audio was generated but could not be downloaded. Try again."
          : "No dubbed audio was produced for this video.",
        "error"
      );
      return;
    }
    setAudioTracks((prev) => {
      const { next, replaced, added } = mergeAudioTracks(prev, tracks);
      const detail = describeMerge({ replaced, added }, languageName);
      showToast(`Dubbed audio ready — ${detail}. Preview it, then Save.`);
      return next;
    });
  };

  const handleStudioTrailer = (result) => {
    const row = trailerResultToRow(result);
    if (!row) return;
    // Only seed a trailer when there isn't one — an existing trailer row may
    // already carry an operator-attached file we must not discard.
    setTrailersList((prev) => (prev.length > 0 ? prev : [row]));
    showToast("Trailer ready — check the Trailers section.");
  };

  const handleStudioThumbnails = (result) => {
    if (!result?.vttUrl) return;
    setThumbnailsData({
      vttUrl: result.vttUrl,
      spriteUrl: result.spriteUrl,
      frameCount: result.frameCount,
      interval: result.interval,
    });
    showToast(
      `Scrubbing previews ready — ${result.frameCount} frame(s) every ${result.interval}s.`
    );
  };

  // Languages that already have a subtitle / audio track, so the launcher can mark
  // those chips with a ✓ — an operator can then tell at a glance whether picking a
  // language means creating it or replacing what's there.
  const studioSubtitleLangs = React.useMemo(() => {
    const set = new Set();
    (subtitleFiles || []).forEach((f) => {
      if (f?.language) set.add(String(f.language).toLowerCase());
    });
    return set;
  }, [subtitleFiles]);

  const studioDubLangs = React.useMemo(() => {
    const set = new Set();
    (audioTracks || []).forEach((t) => {
      const code = t?.languageCode || t?.language;
      if (code) set.add(String(code).toLowerCase());
    });
    return set;
  }, [audioTracks]);

  // Best available human name for the selected video, for the launcher's headline.
  const studioVideoName =
    video?.name ||
    video?.title ||
    video?.original_filename ||
    video?.file_name ||
    "";

  useEffect(() => {
    const fetchHeader = async () => {
      if (seriesId && seasonId) {
        try {
          const res = await SeasonShowApi(seriesId, seasonId);
          const data = res?.data?.data || res?.data;
          if (data) {
            setSeasonHeader({
              name: data.name || "Season Name",
              number: data.season_number ? `Season ${data.season_number}` : ""
            });
          }
        } catch (err) {
          console.error("Error fetching season details:", err);
        }
      }
    };
    fetchHeader();
  }, [seriesId, seasonId]);
  useEffect(() => {
    const fetchSeriesList = async () => {
      try {
        if (formData["content-type"] === "Series") {
          const seriesRes = await prefillSeriesListApi();
          setSeriesList((seriesRes?.data?.data || []).map((item) => ({ id: item.id, name: item.name || item.title })));
        } else {
          if (movieData && !isEditing) {
            setFormData((prev) => ({
              ...prev,
              name: movieData.name || "",
              "content-type": movieData["content-type"],
              genres: Array.isArray(movieData.genres) && movieData.genres.length > 0
                ? movieData.genres.join(",")
                : movieData.genres || "",
              rating: movieData.rating || "",
              access: movieData.access || "",
              description: movieData.description || "",
              portrait: movieData.portrait || null,
              landscape: movieData.landscape || null,
            }));
          }
        }
      } catch (error) {
        showToast("Failed to fetch series list", "error");
      }
    };
    fetchSeriesList();
  }, [movieData, isEditing]);

  // Prefill EXISTING saved audio tracks (incl. AI dubs) when editing, so they show
  // in the Audio Tracks list — mirroring how subtitles reload on edit. Without this,
  // a saved dub is invisible in the CMS (though it plays in the app) and a re-save
  // would drop it (its numeric id → audio_tracks_keep_ids relies on it being here).
  // Runs once per load: only seeds when the list is still empty so it never clobbers
  // freshly generated (unsaved) tracks.
  const audioPrefilledRef = useRef(false);
  useEffect(() => {
    if (audioPrefilledRef.current) return;
    const existing = Array.isArray(movieData?.audio_tracks) ? movieData.audio_tracks : [];
    if (existing.length === 0) return;
    audioPrefilledRef.current = true;
    setAudioTracks((prev) => {
      if (prev && prev.length > 0) return prev; // don't overwrite unsaved edits
      return existing.map((a) => ({
        id: a.id, // numeric DB id → preserved via audio_tracks_keep_ids on save
        language: a.language || a.languageCode || "",
        languageCode: a.languageCode || a.language || "",
        format: a.format || "m4a",
        label: a.label || "",
        dubbed: Boolean(a.dubbed ?? a.is_dubbed),
        voice: a.voice || "",
        previewUrl: a.url || null, // existing CDN url — plays in the in-CMS preview
        isExisting: true,
      }));
    });
  }, [movieData]);

  useEffect(() => {
    const fetchSeasonList = async () => {
      if (formData["content-type"] === "Series" && formData.series_id) {
        try {
          const seasonRes = await prefillSeasonListApi(formData.series_id);
          setSeasonList((seasonRes?.data?.data || []).map((item) => ({ name: item.name, season_id: item.season_id || item.id })));
        } catch (error) {
          showToast("Failed to fetch season list", "error");
        }
      }
    };
    fetchSeasonList();
  }, [formData["content-type"], formData.series_id]);

  useEffect(() => {
    const fetchGenresAndCategories = async () => {
      try {
        const genresResponse = await GenresList();
        const categoriesResponse = await categoriesList();
        let categories = categoriesResponse?.data?.data || [];
        if (episode !== "episode") {
          categories = categories.filter((item) => item.id !== "series");
        }
        setCategoriesData(categories);
        setGenresDataList(genresResponse?.data?.data || []);
      } catch (error) {
        showToast("Failed to load categories or genres", "error");
      }
    };
    fetchGenresAndCategories();
  }, [movieId]);

  const toDateTimeLocalNoTZ = (utcTime) => {
    if (!utcTime) return "";
    return utcTime.replace("Z", "").slice(0, 16);
  };
  const toDateOnly = (isoString) => {
    if (!isoString) return "";
    return isoString.slice(0, 10);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        let isFreshVideoPick = false;
        const nextEpisode = nextEpisodeNumber || location.state?.nextEpisodeNumber;
        const isEpisode = resolvedMovieId && seriesId && seasonId && nextEpisode;
        if (isEpisode) {
          const queryParams = hasMetaFalseParam || !metadata_id ? { meta: false } : {};
          response = await MovieDataList(resolvedMovieId, "", queryParams);
          seriesBannerImage.current = response?.data?.landscape;
          seriesPortraitImage.current = response?.data?.portrait;
        } else if (isEditing) {
          const apiId = metadata_id || params?.id || resolvedMovieId;
          if (!apiId) { showToast("Error: Missing video ID for editing", "error"); return; }
          const queryParams = hasMetaFalseParam ? { meta: false } : {};
          response = await MovieDataList(apiId, "", queryParams);
        } else if (hasMetaFalseParam && (resolvedMovieId || params?.id)) {
          isFreshVideoPick = true;
          const apiId = resolvedMovieId || params?.id;
          response = await MovieDataList(apiId, "", { meta: false });
          seriesBannerImage.current = response?.data?.landscape;
          seriesPortraitImage.current = response?.data?.portrait;
        }

        const data = response?.data;
        if (!data) return;

        setMovieData(data);
        setVideo(data);
        if (data.video_id) {
          actualFetchedVideoId.current = data.video_id;
        }

        // other_info may come back as a JSON string or an object — normalize it
        let otherInfo = data.other_info;
        if (typeof otherInfo === "string") {
          try {
            otherInfo = JSON.parse(otherInfo);
          } catch {
            otherInfo = {};
          }
        }
        otherInfo = otherInfo || {};

        const categories = isEditing
          ? (
            Array.isArray(data["content-type"]) && data["content-type"].length > 0
              ? data["content-type"][0]
              : data["content-type"] ?? paramsData ?? ""
          )
          : (
            paramsData
              ? paramsData
              : Array.isArray(data["content-type"]) && data["content-type"].length > 0
                ? data["content-type"][0]
                : data["content-type"] ?? ""
          );

        setFormData((prev) => ({
          ...prev,
          name: data.name ?? data.Title ?? prev.name ?? prev.Title,
          "content-type": categories,
          genres: Array.isArray(data.genres) && data.genres.length > 0
            ? data.genres.join(",")
            : data.genres ?? prev.genres,
          rating: data.rating ?? prev.rating,
          access: data.access ?? prev.access,
          description: data.description ?? prev.description,
          year: data.year ?? prev.year,
          series_id: data.series_id ?? prev.series_id,
          season_id: data.season_id ?? prev.season_id,
          episode_number: data.episode_number ?? prev.episode_number,
          portrait: data.portrait ?? prev.portrait,
          landscape: data.landscape ?? prev.landscape,
          release_date: toDateOnly(data.release_date) ?? prev.release_date,
          language: data.language ?? prev.language,
          country: data.country ?? prev.country,
          tagline: data.tagline ?? prev.tagline,
          studio: data.studio ?? prev.studio,
          imdb_id: data.imdb_id ?? prev.imdb_id,
          // A saved "0" / non-positive duration is treated as empty.
          duration: Number(data.duration) > 0 ? data.duration : (prev.duration ?? ""),
          content_warning: data.content_warning ?? prev.content_warning,
          badges: data.badge ?? prev.badges,
          live_type: otherInfo.live_type ?? prev.live_type,
          url: otherInfo.url ?? prev.url,
          event_type: otherInfo.live_type ?? prev.event_type,        // ← "Live Type" dropdown
          schedule_type: otherInfo.event_type ?? prev.schedule_type, // ← "Event Type" dropdown
          processed_HLS_URL: otherInfo.processed_HLS_URL ?? prev.processed_HLS_URL,
          stream_type: otherInfo.stream_type ?? prev.stream_type,
          liveStatus: otherInfo.liveStatus ?? prev.liveStatus,
          start_time: toDateTimeLocalNoTZ(otherInfo.start_time) ?? prev.start_time,
          end_time: toDateTimeLocalNoTZ(otherInfo.end_time) ?? prev.end_time,
          rtmp_ingest_url: otherInfo.rtmp_ingest_url ?? otherInfo.url ?? prev.rtmp_ingest_url,
          stream_input_url: otherInfo.stream_input_url ?? otherInfo.url ?? prev.stream_input_url,
          source_type: otherInfo.source_type ?? prev.source_type,
          media_video_id: otherInfo.media_video_id ?? data.media_video_id ?? prev.media_video_id,
          loop: typeof otherInfo.loop === "boolean" ? otherInfo.loop : prev.loop,
        }));

        setImagePreviewURL(data.portrait ?? null);
        setBannerPreviewURL(data.landscape ?? null);
        if (data.title_logo_url) setLogoPreviewURL(data.title_logo_url);
        if (data.preview_url) setHeroPreviewURL(data.preview_url);
        // Note: existing subtitles are prefilled by MediaAssets via `onSubtitleChange`
        // when it receives `movieData.subtitles`, so we don't need to set parent
        // state here. The child sends a merged list (existing + new) every time.

        // Cast/Crew refactor — actor management:
        // GET response now includes a nested `member` object (id, name, image_url) on each cast/crew row.
        // We rebuild castMembers state from member_id + the inline member data — no extra API lookup needed.
        // Crew rows are grouped by member_id so a person with multiple roles becomes one entry with a role array.
        const hasCasts = Array.isArray(data.casts) && data.casts.length > 0;
        const hasCrews = Array.isArray(data.crews) && data.crews.length > 0;
        if (hasCasts || hasCrews) {
          let nextId = Date.now();

          const castEntries = hasCasts
            ? data.casts.map((c) => ({
              id: nextId++,
              type: "Cast",
              actorId: c.member_id,
              actorName: c.member?.name || "",
              image_url: c.member?.image_url || "",
              role: c.role || "ACTOR",
              character: c.character_name || "",
            }))
            : [];

          const crewByMember = hasCrews
            ? data.crews.reduce((acc, c) => {
              if (!acc[c.member_id]) {
                acc[c.member_id] = {
                  member: c.member || {},
                  roles: [],
                };
              }
              if (c.role) acc[c.member_id].roles.push(c.role);
              return acc;
            }, {})
            : {};

          const crewEntries = Object.entries(crewByMember).map(
            ([memberId, { member, roles }]) => ({
              id: nextId++,
              type: "Crew",
              actorId: Number(memberId),
              actorName: member?.name || "",
              image_url: member?.image_url || "",
              role: roles,
              character: "",
            })
          );

          setCastMembers([...castEntries, ...crewEntries]);
        }

        if (data.max_quality || data.frame_rate || data.hdr || data.aspect_ratio || data.drm || data.max_streams || data.geo_restrictions) {
          setTechnicalData((prev) => ({
            ...prev,
            max_quality: data.max_quality ?? prev.max_quality,
            frame_rate: data.frame_rate ?? prev.frame_rate,
            hdr: data.hdr ?? prev.hdr,
            aspect_ratio: data.aspect_ratio ?? prev.aspect_ratio,
            drm: data.drm ?? prev.drm,
            max_streams: data.max_streams ?? prev.max_streams,
            geo_restrictions: data.geo_restrictions ?? prev.geo_restrictions,
          }));
        }

        setPublishingData((prev) => ({
          ...prev,
          ...mapPublishingFromApi(data, prev, { trustStatus: !isFreshVideoPick }),
          publishing_date: toDateOnly(data.publishing_date) ?? prev.publishing_date,
          ppvPrice: data.ppv_price ?? prev.ppvPrice,
          licenseExpiry: toDateOnly(data.license_expiry) ?? prev.licenseExpiry,
          featuredPlacement: data.featured_placement ?? prev.featuredPlacement,
          featuredUntil: toDateOnly(data.featured_until) ?? prev.featuredUntil,
        }));

        if (data.imdb_rating || data.rotten_tomatoes || data.awards) {
          setRatingsData((prev) => ({
            ...prev,
            imdb: data.imdb_rating ?? prev.imdb,
            rottenTomatoes: data.rotten_tomatoes ?? prev.rottenTomatoes,
            awards: data.awards ?? prev.awards,
          }));
        }

        if (Array.isArray(data.trailers) && data.trailers.length > 0) {
          setTrailersList(data.trailers.map((t) => {
            // Map existing subtitle URLs into the subtitleFiles slots
            // We store objects { name, url, isExisting: true } instead of File objects
            const subtitleFiles = [null, null, null];
            const subtitlesEnabled = Array.isArray(t.trailer_subtitles) && t.trailer_subtitles.length > 0;

            if (subtitlesEnabled) {
              t.trailer_subtitles.forEach((sub, idx) => {
                if (idx < 3) {
                  subtitleFiles[idx] = {
                    name: `${sub.language}.${sub.format}`,   // e.g. "en.srt"
                    url: sub.subtitle_url,
                    language: sub.language,
                    format: sub.format,
                    id: sub.id,
                    isExisting: true,                          // flag: not a real File
                  };
                }
              });
            }

            return {
              id: t.id ?? Date.now(),
              label: t.title ?? "",
              type: t.trailer_type ?? "",
              description: t.description ?? "",
              url: t.external_url || "",
              duration: t.duration ?? null,
              videoFile: t.play_link ? { title: t.title, HLSPlaylistURL: t.play_link } : null,
              thumbnail: t.thumbnail ?? null,
              subtitlesEnabled,
              subtitleFiles,
              expanded: false,
              saved: true,
            };
          }));
        }

      } catch (error) {
        showToast(error?.response?.data?.message || "Failed to fetch data", "error");
      }
    };

    const nextEpisode = nextEpisodeNumber || location.state?.nextEpisodeNumber;
    const isEpisodeEditing = resolvedMovieId && seriesId && seasonId && nextEpisode;

    if (isEpisodeEditing || isEditing || (hasMetaFalseParam && (resolvedMovieId || params?.id))) {
      fetchData();
    }
  }, [movieId, seriesId, seasonId, isEditing, params?.id, nextEpisodeNumber]);

  const handleimagesvalue = (item) => {
    if (activeImageType.startsWith("trailer-video-")) {
      const trailerId = parseInt(activeImageType.replace("trailer-video-", ""));
      setTrailersList((prev) => prev.map((t) => (t.id === trailerId ? { ...t, videoFile: item } : t)));
    } else if (activeImageType === "portrait") {
      setIsPortraitUploaded(true);
      setImagePreviewURL(item);
      setFormData((prev) => ({ ...prev, portrait: item.id }));
    } else if (activeImageType === "landscape") {
      setIsLandscapeUploaded(true);
      setBannerPreviewURL(item);
    } else if (activeImageType === "logo") {
      setLogoPreviewURL(item);
      setFormData((prev) => ({ ...prev, logo: item.id }));
    } else if (activeImageType === "hero") {
      setHeroPreviewURL(item);
      // AFTER
    } else if (activeImageType === "video") {
      setVideo(item);
      if (item?.id) {
        actualFetchedVideoId.current = item.id;
        selectedLibraryVideoId.current = item.id;
        // For Live Channel / Live Event with source_type "media", the picked
        // library video becomes `media_video_id` in the payload (see §3.2 / §8.3-8.4
        // of the live-streaming spec).
        const isLiveContent =
          formData["content-type"] === "Live Channel" ||
          formData["content-type"] === "Live Event";
        if (isLiveContent) {
          setFormData((prev) => ({
            ...prev,
            media_video_id: item.id,
            source_type: "media", // picked from Media Library → source is "media"
          }));
        }
      }
    }
  };

  // When the video is removed or replaced by one with no known length (local
  // file, pasted URL), drop the duration auto-detected from the previous video
  // and unlock the field so the user can enter it.
  useEffect(() => {
    if (!durationPrefilled) return;
    if (Math.round(Number(video?.length)) > 0) return;
    setDurationPrefilled(false);
    setDurationAutoFilled(false);
    setFormData((prev) => ({ ...prev, duration: "" }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video]);

  const handleSelectVideos = (item) => {
    if (activeImageType === "video") {
      setVideo(item);
      selectedLibraryVideoId.current = item?.id || null;

      if (item?.id) {
        actualFetchedVideoId.current = item.id;
        const isLiveContent =
          formData["content-type"] === "Live Channel" ||
          formData["content-type"] === "Live Event";
        if (isLiveContent) {
          setFormData((prev) => ({
            ...prev,
            media_video_id: item.id,
            source_type: "media", // picked from Media Library → source is "media"
          }));
        }
        // Auto-fill Duration from the video's real, Bunny-encoded length
        // (already fetched onto this same object — it's what powers the
        // runtime badge in the Media Library grid). Stored as-is in raw
        // seconds, NOT converted to minutes: the backend saves whatever's
        // in this field verbatim as Video.length (seconds, no conversion),
        // so filling in a minutes-shaped number here would silently save a
        // ~60x-too-small duration — the exact bug this fix exists to close.
        // A newly picked video always overwrites the field with its own
        // detected length, so switching videos never leaves a stale value.
        const detectedSeconds = Math.round(Number(item?.length));
        if (detectedSeconds > 0) {
          setFormData((prev) => ({ ...prev, duration: String(detectedSeconds) }));
          setDurationAutoFilled(true);
          setDurationPrefilled(true);
        }
      }
    } else if (activeImageType === "hero") {
      setHeroPreviewURL(item);
    } else {
      setSelectedVideos(item);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    try {
      // Once the user edits an AI-populated field, it's no longer "AI generated"
      // — drop the badge for that field.
      setAiFields((prev) => {
        if (!prev.has(name)) return prev;
        const next = new Set(prev);
        next.delete(name);
        return next;
      });

      // Same idea for the Duration auto-fill note — once hand-edited, the
      // clarifying "auto-filled in seconds" note no longer applies.
      if (name === "duration" && durationAutoFilled) setDurationAutoFilled(false);

      if (name === "landscape" || name === "portrait") setIsOpen(true);

      if ((name === "portrait" || name === "landscape") && selectedImage?.bunny_cdn_url) {
        setFormData((prev) => ({ ...prev, [name]: selectedImage.bunny_cdn_url }));
        if (name === "portrait") { setIsPortraitUploaded(true); setImagePreviewURL(selectedImage.bunny_cdn_url); }
        else { setIsLandscapeUploaded(true); setBannerPreviewURL(selectedImage.bunny_cdn_url); }
        return;
      }

      setFormData((prev) => {
        const updated = { ...prev, [name]: value };

        if (name === "series_id") {
          updated.episode_number = "";
          updated.season_id = "";
          setSeasonList([]);
        }

        if (name === "content-type" && value !== "Series") {
          updated.series_id = "";
          updated.episode_number = "";
          updated.season_id = "";
          setSeriesList([]);
          setSeasonList([]);
        }
        if (name === "content-type" && (value === "Live Channel" || value === "Live Event")) {
          const pickedVideoId = video?.id || selectedLibraryVideoId.current;
          if (pickedVideoId) {
            updated.media_video_id = pickedVideoId;
            updated.source_type = "media";
          }
        }

        // source_type toggles between "url" and "media".
        // Only ever keep the field relevant to the selected mode —
        // clear the other one so a stale value can't leak into the payload
        // (spec §15: "loop is only supported when source_type is media").
        if (name === "source_type") {
          if (value === "media") {
            updated.url = "";
          } else if (value === "url") {
            updated.media_video_id = null;
          }
        }

        return updated;
      });
    } catch (error) {
      showToast(error?.response?.data?.message || "Error processing input", "error");
    }
  };

  const handleIconClick = (type) => {
    setActiveImageType(type);
    setIsOpen(true);
  };

  const handleSubmit = async (e, type, buttonType) => {
    e.preventDefault?.();

    if (isCreator() && !rightsConfirmed) {
      setShowRightsError(true);
      showToast(CONTENT_RIGHTS_ERROR, "error");
      return;
    }

    const isLive =
      formData["content-type"] === "Live Channel" ||
      formData["content-type"] === "Live Event";

    if (isLive && !formData.liveStatus) {
      showToast("Please choose a Live Status", "error");
      return;
    }
    if (formData["content-type"] === "Live Event" && !formData.schedule_type) {
      showToast("Please choose a scheduling option", "error");
      return;
    }

    const scheduleType = formData.schedule_type?.toLowerCase()?.trim();
    const isScheduledEvent = formData["content-type"] === "Live Event" && scheduleType === "scheduled";

    if (isScheduledEvent) {
      if (!formData.start_time) { showToast("Start time is required for scheduled events", "error"); return; }
      if (!formData.end_time) { showToast("End time is required for scheduled events", "error"); return; }
      if (new Date(formData.end_time) <= new Date(formData.start_time)) {
        showToast("End time must be after start time", "error");
        return;
      }
    }

    // Live Channel / Live Event stream source validation (spec §15)
    if (isLive) {
      const sourceType = formData.source_type === "media" ? "media" : "url";
      if (sourceType === "media") {
        // if (!formData.media_video_id) {
        //   showToast("Stream source is required — select a media video", "error");
        //   return;
        // }
      } else {
        const hasUrl = Boolean(
          (formData.stream_input_url && formData.stream_input_url.trim()) ||
          (formData.rtmp_ingest_url && formData.rtmp_ingest_url.trim()) ||
          (formData.url && formData.url.trim())
        );
        if (!hasUrl) {
          showToast("Stream source is required — enter an RTMP or HLS URL", "error");
          return;
        }
      }
    }

    if (trailersList.length > 0) {
      const t = trailersList[0];
      const hasTrailerLabel = typeof t.label === "string" && t.label.trim() !== "";
      const hasTrailerVideo = Boolean(
        t.videoFile?.id ||
        t.videoFile?.HLSPlaylistURL ||
        t.videoFile?.play_link ||
        t.videoFile?.bunny_cdn_url ||
        (typeof t.url === "string" && t.url.trim() !== "")
      );
      if (hasTrailerLabel && !hasTrailerVideo) {
        showToast("Please select a video file for the trailer.", "error");
        return;
      }
      if (!hasTrailerLabel && hasTrailerVideo) {
        showToast("Please enter a trailer title.", "error");
        return;
      }
    }

    // Main Video URL is required whenever its field is actually shown — mirrors
    // MediaAssests.js's own `showMainVideoSection` (top-level Series/Season rows
    // have no Main Video section at all, and Live content already validated its
    // stream source above). A file picked directly still populates formData.url
    // (see handleVideoFilePick), so this also catches "removed the URL and never
    // picked a replacement" regardless of how the media was meant to be added.
    const isSeriesForm = formData?.["content-type"] === "Series" || hash.includes("/Addseries");
    const isSeasonForm = hash.includes("/add");
    const isEpisodeForm = hash.split("/").length >= 5 && hash.includes("/video/");
    const showsMainVideoSection = (!isSeriesForm || isEpisodeForm) && !isSeasonForm;

    if (!isLive && showsMainVideoSection && !(formData.url && formData.url.trim())) {
      showToast("Media link is required. Please add one before saving.", "error");
      return;
    }

    // Category / Sub Category is mandatory for Save Draft as well as Publish,
    // but only on the forms that actually render the field -- the episode and
    // season flows hide it (see showAccessControls in Publishing.js), so they
    // must not be blocked by a field the user can't see.
    // showsCategorySection comes from the shared showsPlacementSection() helper
    // (computed above), the same one <Publishing> renders off -- validating on
    // a different rule than the one that shows the field would block a save
    // over something the user was never shown.
    if (showsCategorySection) {
      const placementError = validateCategoryPlacements(publishingData, loadedSections, {
        sectionsComplete,
      });
      if (placementError) {
        setShowPlacementErrors(true);
        // The Publishing accordion starts collapsed and unmounts its body, so
        // without this the user gets a toast about a field that isn't on
        // screen and nothing visibly changes.
        ensureRow();
        setActiveAccordion("publishing");
        showToast(placementError, "error");
        return;
      }
    }
    setShowPlacementErrors(false);

    const payload = new FormData();

    /* IMAGES */
    payload.append("portrait",
      imagePreviewURL?.bunny_cdn_url || imagePreviewURL?.id ||
      (typeof movieData?.portrait === "string" ? movieData?.portrait : "") ||
      seriesPortraitImage.current || ""
    );
    payload.append("landscape",
      bannerPreviewURL?.bunny_cdn_url || bannerPreviewURL?.id ||
      (typeof movieData?.landscape === "string" ? movieData?.landscape : "") ||
      seriesBannerImage.current || ""
    );
    // payload.append("status", type);

    /* MEDIA */
    if (trailer?.url || trailer?.bunny_cdn_url || movieData?.trailer?.url) {
      payload.append("trailer", trailer?.url || trailer?.bunny_cdn_url || movieData?.trailer?.url || "");
    }

    /* CAST & CREW */
    const castsPayload = (castMembers || [])
      .filter((c) => c.type === "Cast" && c.actorId)
      .map((c) => ({
        member_id: c.actorId,
        role: c.role || "ACTOR",
        character_name: c.character || "",
      }));
    const crewsPayload = (castMembers || [])
      .filter((c) => c.type === "Crew" && c.actorId)
      .flatMap((c) => {
        const roles = Array.isArray(c.role)
          ? c.role
          : c.role
            ? [c.role]
            : [];
        return roles.map((r) => ({ member_id: c.actorId, role: r }));
      });
    payload.append("casts", JSON.stringify(castsPayload));
    payload.append("crews", JSON.stringify(crewsPayload));

    /* SUBTITLES */
    // Main video subtitles only. Trailer subtitles are handled separately in the
    // trailer block below — sending them as `trailer_subtitles` to a different
    // backend handler.
    const subtitlesMeta = [];
    const subtitleFilesArray = [];
    // Main subtitle slots: existing rows (loaded from server) are kept by sending
    // their ids in `subtitles_keep_ids`; only newly-picked File objects are uploaded.
    const keptSubtitleIds = [];
    (subtitleFiles || []).forEach((file, idx) => {
      if (!file) return;
      if (file.isExisting) {
        if (file.id != null) keptSubtitleIds.push(file.id);
        return;
      }
      // Prefer an explicit language/format carried on the file (AI-generated
      // subtitles, or a future language picker); otherwise fall back to the
      // positional default so manually-picked files behave exactly as before.
      const language = file.language || (idx === 0 ? "en" : idx === 1 ? "hi" : "other");
      const format = file.format || (file.name?.endsWith(".vtt") ? "vtt" : "srt");
      subtitlesMeta.push({ language, format });
      subtitleFilesArray.push(file);
    });
    if (subtitleFilesArray.length > 0) {
      subtitleFilesArray.forEach((file) => payload.append("subtitles", file));
      payload.append("subtitles", JSON.stringify(subtitlesMeta));
    }
    // Always send keep-ids (even when empty) so the backend can distinguish
    // "no subtitle changes intended" from "user removed everything".
    payload.append("subtitles_keep_ids", JSON.stringify(keptSubtitleIds));
    const logoUrl =
      logoPreviewURL    // will be null after removal
        ? (logoPreviewURL?.title_logo_url || logoPreviewURL?.bunny_cdn_url ||
          logoPreviewURL?.url || (typeof logoPreviewURL === "string" ? logoPreviewURL : null) ||
          movieData?.title_logo_url || "")
        : "";           // cleared — send empty string
    payload.append("title_logo_url", logoUrl);

    const heroUrl =
      heroPreviewURL
        ? (heroPreviewURL?.preview_url || heroPreviewURL?.bunny_cdn_url ||
          heroPreviewURL?.HLSPlaylistURL || (typeof heroPreviewURL === "string" ? heroPreviewURL : null) ||
          movieData?.preview_url || "")
        : "";
    payload.append("preview_url", heroUrl);

    const isEpisodePayload = formData["content-type"] === "Series" && formData.series_id && formData.season_id;
    const episodeVideoUrl = formData.processed_HLS_URL || formData.url || "";

    const videoWasExplicitlyTouched = video && Object.prototype.hasOwnProperty.call(video, "id");

    // Only trust the "picked from Media Library" ref if `video` still actually
    // points at that same picked item. If the user cleared the URL, typed a
    // different one, or uploaded a new file directly after picking from the
    // library, `video.id` will no longer match the ref — so the stale id is
    // NOT reused. Also never send `video_id` for live content — live sends
    // `media_video_id` separately in the `other_info` block below.
    const libraryPickedId =
      !isLive &&
        video &&
        !(video instanceof File) &&
        video.id &&
        video.id === selectedLibraryVideoId.current
        ? selectedLibraryVideoId.current
        : null;

    const fallbackExistingId = actualFetchedVideoId.current || resolvedMovieId || params?.id || "";

    if (libraryPickedId) {
      // Real id from a Media Library pick.
      payload.append("video_id", libraryPickedId);
    } else if (!isLive && videoWasExplicitlyTouched && episodeVideoUrl) {
      payload.append("play_link", episodeVideoUrl);
    } else if (!isLive) {
      // Nothing touched — keep sending the existing video's real id.
      payload.append("video_id", fallbackExistingId);
    }

    if (metadata_id) payload.append("metadata_id", metadata_id);

    /* OTHER_INFO — only for live content, sent as JSON string.
       Follows the field reference in LIVE_STREAMING_FRONTEND.md §9:
       source_type / url / stream_type / live_type / event_type / start_time /
       end_time / media_video_id / loop. */
    if (isLive) {
      const other_info = {};
      const sourceType = formData.source_type === "media" ? "media" : "url";
      other_info.source_type = sourceType;

      // live_type — inferred from content-type, but honor the explicit
      // "Live Type" dropdown (formData.event_type) when the user set it.
      other_info.live_type =
        formData["content-type"] === "Live Event" ? "Event"
          : formData["content-type"] === "Live Channel" ? "Channel" : "";
      if (formData.event_type === "Live Event") other_info.live_type = "Event";
      if (formData.event_type === "Live Channel") other_info.live_type = "Channel";

      if (sourceType === "media") {
        // Media mode: send media_video_id only, never a URL (spec §3.2, §5).
        if (formData.media_video_id) {
          other_info.media_video_id = formData.media_video_id;
          payload.append("media_video_id", formData.media_video_id);
        }
        // Explicitly clear url so a stale value from a previous edit
        // (or a mode the user switched away from) can't leak through.
        payload.append("url", "");
      } else {
        // URL mode: single stream URL, auto-detect rtmp vs hls (spec §3.1).
        const streamUrl =
          formData.url || formData.stream_input_url || formData.rtmp_ingest_url || "";
        other_info.url = streamUrl;
        other_info.stream_type = streamUrl.trim().toLowerCase().startsWith("rtmp://")
          ? "rtmp"
          : "hls";

        // Send url as a top-level field too, symmetric with media_video_id above.
        payload.append("url", streamUrl);
        // Explicitly clear media_video_id so a stale id can't leak through.
        payload.append("media_video_id", "");
      }

      // Loop applies to any live main video (media pick, uploaded file, or typed
      // URL) — the toggle in MediaAssets renders whenever `videoSrc` exists,
      // regardless of source_type, so it must not be gated behind the "media"
      // branch above or it silently gets dropped from the payload.
      other_info.loop = formData.loop !== false; // default true

      // Live Event scheduling (spec §6) — only for Live Event content-type.
      // schedule_type is now required (validated above), so no silent "instant"
      // fallback — whatever the user explicitly chose is sent as-is.
      if (formData["content-type"] === "Live Event") {
        const normalizedSchedule = formData.schedule_type.toLowerCase().trim();
        other_info.event_type = normalizedSchedule;
        if (normalizedSchedule === "scheduled") {
          if (formData.start_time) other_info.start_time = formData.start_time;
          if (formData.end_time) other_info.end_time = formData.end_time;
        }
      }

      // liveStatus is required for Live Channel/Event (validated above) — always
      // send it explicitly so an "Inactive" selection can't be dropped from the
      // payload and mistaken for "publish anyway" on the backend.
      if (isLive) {
        other_info.liveStatus = formData.liveStatus;
      }
      if (formData.processed_HLS_URL) other_info.processed_HLS_URL = formData.processed_HLS_URL;

      payload.append("other_info", JSON.stringify(other_info));
    }
    payload.append("content-type",
      formData["content-type"] === "Video" ? categoriesData[0]?.name || "" : formData["content-type"]
    );
    /* BASIC INFO FIELDS — always send key, empty string if no value */
    const BASIC_INFO_KEYS = [
      "description", "year", "release_date", "language", "country",
      "tagline", "studio", "imdb_id", "duration",
      "content_warning", "rating",
    ];

    for (const key of BASIC_INFO_KEYS) {
      const val = formData[key];
      const isEmpty = val === null || val === undefined || val === "" || String(val) === "undefined";
      payload.append(key, isEmpty ? "" : val);
    }

    // series_id, season_id, episode_number — only for Series
    if (formData["content-type"] === "Series") {
      payload.append("series_id", formData.series_id || "");
      payload.append("season_id", formData.season_id || "");
      payload.append("episode_number", formData.episode_number || "");
    }

    // name / title — always send key, empty if no value
    const nameVal = formData["name"];
    const nameIsEmpty = nameVal === null || nameVal === undefined || nameVal === "" || String(nameVal) === "undefined";
    const isEpisodeField = formData["content-type"] === "Series" && formData.series_id && formData.season_id;
    payload.append(isEpisodeField ? "name" : "title", nameIsEmpty ? "" : nameVal);

    /* REMAINING formData — skip keys already handled above */
    const ALREADY_HANDLED = new Set([
      ...BASIC_INFO_KEYS,
      "series_id", "season_id", "episode_number",
      "name", "status", "portrait", "landscape",
      "genres", "badges", "logo", "content_warnings", "access", "content-type", "drm",
      "rtmp_ingest_url", "stream_input_url", "schedule_type",
      "url", "media_video_id", "source_type", // handled explicitly in the isLive block above
      ...OTHER_INFO_KEYS,
    ]);

    for (const key in formData) {
      if (ALREADY_HANDLED.has(key)) continue;
      if (
        formData[key] === null || formData[key] === "" || formData[key] === undefined ||
        String(formData[key]) === "undefined"
      ) continue;

      payload.append(key, formData[key]);
    }

    /* GENRES */
    if (formData.genres) {
      const selectedNames = Array.isArray(formData.genres) ? formData.genres : formData.genres.split(",");
      const genreIds = selectedNames
        .map((name) => genresDataList?.find((g) => g.name.toLowerCase() === name.trim().toLowerCase())?.id ?? null)
        .filter(Boolean);
      payload.append("genre_ids", JSON.stringify(genreIds));
    }

    const badgeValue = formData.badges
      ? (Array.isArray(formData.badges) ? formData.badges[0] : formData.badges)
      : "";
    payload.append("badge", String(badgeValue));

    /* TECHNICAL — always send all keys */
    payload.append("drm", technicalData.drm || "");
    payload.append("max_streams", technicalData.max_streams || "");
    payload.append("geo_restrictions", technicalData.geo_restrictions || "");
    payload.append("max_quality", technicalData.max_quality || "");
    payload.append("frame_rate", technicalData.frame_rate || "");
    payload.append("aspect_ratio", technicalData.aspect_ratio || "");
    payload.append("video_codec", technicalData.video_codec || "");
    payload.append("audio_codec", technicalData.audio_codec || "");
    payload.append("bitrate", technicalData.bitrate || "");
    payload.append("hdr", technicalData.hdr || "");
    /* AUDIO TRACKS — detected/added audio languages + AI dubs.
       Mirrors the SUBTITLE flow: a track that carries an actual audio File (an AI
       dub) is uploaded as a file under the `audio_tracks` field, alongside a
       parallel `audio_tracks_meta` JSON describing each uploaded file. Existing
       saved tracks are kept via `audio_tracks_keep_ids`. Metadata-only tracks
       (no file, just describing audio inside the video) go in the meta JSON too
       so the backend can persist them without a file. */
    const audioMeta = [];
    const audioFilesArray = [];
    const keptAudioIds = [];
    (audioTracks || []).forEach((track) => {
      if (!track) return;
      if (track.id != null && String(track.id).match(/^\d+$/)) {
        // Existing saved row (numeric DB id) — keep it.
        keptAudioIds.push(parseInt(track.id, 10));
        return;
      }
      const language = track.languageCode || track.language || "";
      const base = {
        language,
        label: track.label || "",
        format: track.format || (track.file ? "m4a" : ""),
        dubbed: Boolean(track.dubbed),
        voice: track.voice || "",
      };
      if (track.file) {
        // Uploadable dub file — send the File + its meta (index-aligned).
        audioFilesArray.push(track.file);
        audioMeta.push({ ...base, hasFile: true });
      } else {
        // Metadata-only track (no separate audio file).
        audioMeta.push({ ...base, hasFile: false });
      }
    });
    if (audioFilesArray.length > 0) {
      audioFilesArray.forEach((file) => payload.append("audio_tracks", file));
    }
    payload.append("audio_tracks_meta", JSON.stringify(audioMeta));
    payload.append("audio_tracks_keep_ids", JSON.stringify(keptAudioIds));

    /* SEEK-BAR PREVIEW (trickplay) THUMBNAILS — stored in other_info by the backend
       for any content type. Prefer a freshly generated set, else keep whatever the
       content already had so a re-save doesn't wipe existing previews. */
    const thumbVtt =
      thumbnailsData?.vttUrl || movieData?.other_info?.thumbnails_vtt_url || "";
    const thumbSprite =
      thumbnailsData?.spriteUrl || movieData?.other_info?.thumbnails_sprite_url || "";
    if (thumbVtt) payload.append("thumbnails_vtt_url", thumbVtt);
    if (thumbSprite) payload.append("thumbnails_sprite_url", thumbSprite);

    /* PUBLISHING — always send all keys */
    appendPublishingPayload(payload, publishingData, type);

    payload.append("producers", crewData.producers || "");
    payload.append("composers", crewData.composers || "");

    /* RATINGS — always send all keys */
    payload.append("imdb_rating", ratingsData.imdb || "");

    /* TRAILERS */
    if (trailersList.length > 0) {
      const t = trailersList[0];
      const trailerRef =
        t.videoFile?.id ||
        t.videoFile?.HLSPlaylistURL ||
        t.videoFile?.play_link ||
        t.videoFile?.bunny_cdn_url ||
        t.url ||
        "";
      payload.append("trailer", trailerRef);
      payload.append("trailer_name", t.label || "");
      payload.append("trailer_type", t.type || "");
      payload.append("trailer_description", t.description || "");
      payload.append("trailer_duration", t.duration || "");
      payload.append("trailer_thumbnail", t.thumbnail || "");
      payload.append("trailer_external_url", t.external_url || "");

      const slotLanguage = (idx) => (idx === 0 ? "en" : idx === 1 ? "hi" : "other");
      const subtitlesMeta = [];
      const keptTrailerSubtitleIds = [];
      (t.subtitleFiles || []).forEach((file, idx) => {
        if (!file) return;
        if (file.isExisting) {
          if (file.id != null) keptTrailerSubtitleIds.push(file.id);
          return;
        }
        payload.append("trailer_subtitles", file);
        // Detected/picked language (see utils/subtitleLanguage); slot position is
        // only a last resort for a file with no language at all.
        // Prefer the language detected when the file was picked.
        subtitlesMeta.push({ language: file.language || slotLanguage(idx), format: "srt" });
      });
      if (subtitlesMeta.length > 0) {
        payload.append("trailer_subtitles_meta", JSON.stringify(subtitlesMeta));
      }
      payload.append(
        "trailer_subtitles_keep_ids",
        JSON.stringify(keptTrailerSubtitleIds)
      );
    }

    setLoadingState((prev) => ({ ...prev, [buttonType]: true }));
    setLoading(true);

    try {
      const routingId = metadata_id || actualFetchedVideoId.current || resolvedMovieId || params?.id;

      if (formData["content-type"] === "Series" && formData.series_id && formData.season_id) {
        try {
          const episodeResponse = isEditing
            ? await updateTableData(routingId, payload)
            : await addNewEpisode(formData.series_id, formData.season_id, payload);
          showToast(episodeResponse?.data?.message);
          navigate(`/mainlayout/series/${formData.series_id}/seasons/${formData.season_id}/episodes`);
        }
        catch (error) {
          const response = error?.response?.data;
          if (response?.errors) {
            const fieldErrors = Object.values(response.errors).flat();
            showToast(fieldErrors[0] || response.message, "error");
          } else {
            showToast(String(response?.message || "Unexpected error"), "error");
          }
        }
        return;
      }

      let response;
      if (isEditing) {
        response = await moviesUpdate(routingId, payload);
      } else {
        response = await adminContent(payload);
      }

      showToast(response?.data?.message || "Saved successfully!", "success");

      // Category / Sub Category are sent as part of `payload` above and
      // handled server-side: applied immediately for an Admin's own save, or
      // stored as a request for a Creator's (applied on Admin approval --
      // see VideoController.submissionStatusChange).

      // Redirect rule: Series content-type goes to the series list page,
      // everything else (Movie, Podcast, Short Clip, Live Event, Live Channel, "Video", etc.)
      // always goes to the movie page.
      const routeTarget =
        formData["content-type"] === "Series" ? "series" : "movie";

      navigate(`/mainlayout/${routeTarget}`);
      return response;
    } catch (error) {
      const response = error?.response?.data;
      if (response?.errors) {
        const fieldErrors = Object.values(response.errors).flat();
        showToast(fieldErrors[0] || response.message, "error");
      } else {
        showToast(String(response?.message || "Unexpected error"), "error");
      }
    } finally {
      setLoading(false);
      setLoadingState((prev) => ({ ...prev, [buttonType]: false }));
    }
  };
  useEffect(() => {
    return () => {
      if (imagePreviewURL) URL.revokeObjectURL(imagePreviewURL);
      if (bannerPreviewURL) URL.revokeObjectURL(bannerPreviewURL);
    };
  }, [imagePreviewURL, bannerPreviewURL]);

  useEffect(() => {
    if (movieData) {
      if (movieData.portrait && !isPortraitUploaded) setImagePreviewURL(movieData.portrait);
      if (movieData.landscape && !isLandscapeUploaded) setBannerPreviewURL(movieData.landscape);
      setCastList(Array.isArray(movieData.casts) ? movieData.casts : []);
      setCrewList(Array.isArray(movieData.crews) ? movieData.crews : []);
    }
  }, [movieData, isPortraitUploaded, isLandscapeUploaded]);

  useEffect(() => {
    if (movieData?.trailer && !trailer) setTrailer(movieData.trailer);
  }, [movieData?.trailer, trailer]);

  useEffect(() => {
    if (movieData?.video && !video) setVideo(movieData.video);
  }, [movieData?.video, video]);

  const handleCopy = () => {
    const vid = Array.isArray(selectedVideos) ? selectedVideos[0] : selectedVideos;
    const url = vid?.HLSPlaylistURL || movieData?.HLSPlaylistURL;
    if (url) {
      navigator.clipboard.writeText(url)
        .then(() => showToast("URL copied to clipboard!", "success"))
        .catch(() => showToast("Failed to copy!", "error"));
    } else {
      showToast("No playlist URL found", "error");
    }
  };

  const handleAdvanced = () => setShowAdvanced(!showAdvanced);

  const soloProps = { activeId: activeAccordion, setActiveId: setActiveAccordion };

  const isFilled = (...fields) => fields.every(Boolean);

  const isLive =
    formData["content-type"] === "Live Channel" ||
    formData["content-type"] === "Live Event";
  const Episodes = hash.split("/").length >= 5 && hash.includes("/video/");

  return (
    <>
      {/* Unified AI Studio: one launcher after a video is picked, then a background
          run reported by a dock. Renders nothing when AI is switched off or the
          content is live (nothing to analyze).
          `videoKey` changing is what offers the launcher for a new selection. */}
      <AiStudio
        enabled={aiEnabled && !isLiveContent}
        autoOpen={!isEditing}
        video={video}
        videoKey={videoSelectionKey}
        videoName={studioVideoName}
        existingSubtitleLangs={studioSubtitleLangs}
        existingDubLangs={studioDubLangs}
        onMetadata={applyMetadataResult}
        onSubtitles={handleStudioSubtitles}
        onDub={handleStudioDub}
        onTrailer={handleStudioTrailer}
        onThumbnails={handleStudioThumbnails}
        onManual={() => setActiveAccordion("basic")}
      />

      <div className={style.mainContainer}>
        <Sidebar />
        <Layout>
          <div className={style.innerContainer}>
            <div className={style.leftContainer}>

              {/* AI metadata: a button to START analysis when idle (a video is
                  selected, create mode, non-live); once running/done/failed the
                  progress panel takes over. Button-triggered, not automatic. */}
              {canGenerateMetadata && ai.isIdle && !aiDismissed && (
                <div className={style.aiMetadataBar}>
                  <div className={style.aiMetadataBarText}>
                    <p className={style.aiMetadataBarTitle}>Generate metadata with AI</p>
                    <p className={style.aiMetadataBarSub}>
                      Analyzes the selected video and suggests title, description,
                      genres and more. Review before saving.
                    </p>
                  </div>
                  <button
                    type="button"
                    className={style.aiMetadataBtn}
                    onClick={handleGenerateMetadata}
                  >
                    Generate metadata
                  </button>
                </div>
              )}

              {aiEnabled && !ai.isIdle && !aiDismissed && (
                <AiAnalysisProgress
                  status={ai.status}
                  stages={ai.stages}
                  activeStage={ai.activeStage}
                  progress={ai.progress}
                  error={ai.error}
                  filledCount={aiFields.size}
                  onRetry={() => video && ai.analyze(video)}
                  onDismiss={() => setAiDismissed(true)}
                />
              )}

              {Episodes && seasonHeader && (
                <div className={style.seriesNameBox}>
                  <div className={style.headerContent}>
                    <div className={style.seasonTitle}>
                      {seasonHeader.name}
                    </div>
                    <div className={style.seasonSubtitle}>
                      {seasonHeader.number}
                    </div>
                  </div>
                </div>
              )}
              {!isEditing && (imagePreviewURL && bannerPreviewURL && logoPreviewURL && heroPreviewURL) && (
                <div className={style.headingText}>
                  *Your image has successfully uploaded. Complete your submission
                  by adding the metadata below.
                </div>
              )}
              {/* Media & Assets comes first: selecting/uploading the video is
                  the entry point that kicks off AI analysis. Users who prefer to
                  work manually can simply skip it and fill the sections below. */}
              <MediaAssets
                formData={formData}
                handleChange={handleChange}
                handleIconClick={handleIconClick}
                isLandscapeUploaded={isLandscapeUploaded}
                isPortraitUploaded={isPortraitUploaded}
                bannerPreviewURL={bannerPreviewURL}
                imagePreviewURL={imagePreviewURL}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                setSelectedVideos={handleSelectVideos}
                handleimagesvalue={handleimagesvalue}
                setIsPortraitUploaded={setIsPortraitUploaded}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
                portraitInputRef={portraitInputRef}
                handleAdvanced={handleAdvanced}
                showAdvanced={showAdvanced}
                movieData={movieData}
                handleCastCrewChange={handleCastCrewChange}
                selectedVideos={selectedVideos}
                setTrailer={setTrailer}
                setVideo={setVideo}
                video={video}
                onVideoFileChange={setVideo}
                name={name}
                soloProps={soloProps}
                onSubtitleChange={setSubtitleFiles}
                aiSubtitleDrop={aiSubtitleDrop}
                onLogoChange={setLogoFile}
                heroPreviewURL={heroPreviewURL}
                logoPreviewURL={logoPreviewURL}
                onLogoRemove={() => setLogoPreviewURL(null)}
                onHeroRemove={() => setHeroPreviewURL(null)}
                audioTracks={audioTracks}
                onAudioTracksChange={setAudioTracks}
                onThumbnailsChange={setThumbnailsData}
                thumbnailsVtt={
                  thumbnailsData?.vttUrl || movieData?.other_info?.thumbnails_vtt_url || null
                }
                aiFields={aiFields}
              />

              {/* AI auto-fills these real fields directly (title, description,
                  genre, rating, language, etc.) — no separate suggestions panel. */}
              <BasicInformation
                formData={formData}
                handleChange={handleChange}
                isEditing={isEditing}
                categoriesData={categoriesData}
                seriesList={seriesList}
                seasonList={seasonList}
                genresDataList={genresDataList}
                ratingOptions={ratingOptions}
                accessOptions={accessOptions}
                eventData={eventData}
                streamData={streamData}
                statusData={statusData}
                mediaLibrary={mediaLibrary}
                soloProps={soloProps}
                nameFromState={name}
                aiFields={aiFields}
                durationAutoFilled={durationAutoFilled}
                durationPrefilled={durationPrefilled}
              />

              {(!isLive && !Episodes) && (
                <TrailerClips
                  movieData={movieData}
                  handleCastCrewChange={handleCastCrewChange}
                  selectedVideos={selectedVideos}
                  setSelectedVideos={setSelectedVideos}
                  setTrailer={setTrailer}
                  setVideo={setVideo}
                  trailersList={trailersList}
                  setTrailersList={setTrailersList}
                  soloProps={soloProps}
                  contentTitle={formData.name}
                  sourceVideo={video}
                />
              )}

              {(!isLive && !Episodes) && (
                <CastCrewMembers
                  movieData={movieData}
                  handleCastCrewChange={handleCastCrewChange}
                  selectedVideos={selectedVideos}
                  setSelectedVideos={setSelectedVideos}
                  setTrailer={setTrailer}
                  setVideo={setVideo}
                  crewData={crewData}
                  setCrewData={setCrewData}
                  castMembers={castMembers}
                  setCastMembers={setCastMembers}
                  ratingsData={ratingsData}
                  setRatingsData={setRatingsData}
                  soloProps={soloProps}
                />
              )}
              {!Episodes && (
                <Technical
                  soloProps={soloProps}
                  formData={formData}
                  handleChange={handleChange}
                  technicalData={technicalData}
                  setTechnicalData={setTechnicalData}
                  aiFields={aiFields}
                />
              )}

              <Publishing
                soloProps={soloProps}
                publishingData={publishingData}
                setPublishingData={setPublishingData}
                showPlacementErrors={showPlacementErrors}
                sections={loadedSections}
                sectionsError={sectionsError}
                sectionsLoading={sectionsLoading}
              />

              <ContentRightsConfirmation
                checked={rightsConfirmed}
                onChange={(v) => {
                  setRightsConfirmed(v);
                  if (v) setShowRightsError(false);
                }}
                showError={showRightsError}
              />

              <div className={style.buttonWrapper}>
                <div className={style.readyToGoLiveBanner}>
                  <div className={style.readyToGoLiveLeft}>
                    <span className={style.readyToGoLiveTitle}>Ready To Go Live?</span>
                    <span className={style.readyToGoLiveMeta}>
                      {formData.name} &middot; {formData["content-type"]?.toLowerCase()}
                    </span>
                  </div>
                  <div className={style.btnBox}>
                    <Button
                      className={style.publishNowBtn}
                      onClick={(e) => handleSubmit(e, publishingData.status, "Publish")}
                      loading={loadingState.Publish}
                    >
                      Save Changes
                    </Button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </Layout>
      </div>
    </>
  );
};

export default ImageFileUpload;